import axios from "axios";
import router from "@/router";

const redirectInterceptor = axios.create({});

// attach latest token before each request
redirectInterceptor.interceptors.request.use(function (config) {

    const token = localStorage.getItem("theyr_access_token");



    if (token && config.url && config.url.includes("nav.theyr.com")) {

        config.headers["Authorization"] = "Bearer " + token;
    }



    return config;
});


redirectInterceptor.interceptors.response.use(
    function (response) {
        return response;
    },

    function (error) {

        if (!error.response || !error.config) {
            return Promise.reject(error);
        }

        var status = error.response.status;
        var url = error.config.url || "";

        // THEYR API expired → reload page to re-authenticate
        if (status === 401 && url.includes("nav.theyr.com")) {


            window.location.reload();

            return;
        }

        // normal backend auth
        if (status === 401 || status === 403) {
            router.push("/login");
        }

        return Promise.reject(error);
    }
);

export default redirectInterceptor;
